export default (function () {
    document.querySelectorAll('[data-toggle-button]').forEach((element) => {
        element.addEventListener('click', () => {
            const attributeValue = element.dataset.toggleButton
            element.classList.toggle('!hidden')
            document.querySelector('[data-toggle-target="' + attributeValue + '"]').classList.toggle('hidden')
        })
    })

    document.querySelectorAll('[data-expandable]').forEach((element) => {
        element.addEventListener('keypress', (e) => {
            e.preventDefault()
            if (e.keyCode === 32) {
                const expanded = element.parentElement.getAttribute('aria-expanded') === 'true'
                element.parentElement.setAttribute('aria-expanded', (expanded ? 'false' : 'true'))
            }
        })
    })
})
